import React, { useEffect, useState } from 'react';
import Chart, { ArgumentAxis, Border, Legend, Series, Size } from 'devextreme-react/chart';
import { CardAnalytics } from '../../library/card-analytics/CardAnalytics';
export const RevenueCard = (data) => {
    const [chartData, setChartData] = useState([]);
    useEffect(() => {
        setChartData(data);
    }, []);
    return (
        <CardAnalytics title='Onderhoud in dit jaar' contentClass='sales'>
            <Chart
                palette='Harmony Light'
                dataSource={chartData}>
                <Border visible />
                <Series valueField='TotalServices' argumentField='Month' type='splinearea' name='TotalServices' color='#79cac4' />
                <ArgumentAxis valueMarginsEnabled={false} />
                <Legend
                    verticalAlignment='bottom'
                    horizontalAlignment='center'
                />
                <Size height={270} />
            </Chart>
  </CardAnalytics>
    );
};
